export enum EPermissaoAplication {
  TODOS = 0,
  ADMINISTRADOR = 1,
  USUARIO = 2,
}